import React, { useEffect, useState } from "react";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";

const fmt = (n) => `£${Number(n || 0).toLocaleString("en-GB", { maximumFractionDigits: 2 })}`;

export function UnmatchedTab({ onChange }) {
  const [groups, setGroups] = useState(null);
  const [clients, setClients] = useState([]);
  const [pick, setPick] = useState({});
  const [open, setOpen] = useState(null);
  const load = () => api.get("/client-master/unmatched-invoices").then((r) => setGroups(r.data));
  useEffect(() => { load(); api.get("/clients").then((r) => setClients(r.data)); }, []);

  async function assign(g) {
    try {
      const r = await api.post("/client-master/unmatched/assign", { contact_id: g.contact_id || null, contact_name: g.contact_name, client_id: pick[g.key] });
      toast.success(`Assigned · ${r.data.backfilled} invoice(s) matched`); load(); onChange();
    } catch (e) { toast.error(formatErr(e.response?.data?.detail)); }
  }

  if (!groups) return <div className="text-sm text-[var(--ink-2)]">Loading…</div>;
  if (!groups.length) return <div className="card-flat p-8 text-center text-sm text-[var(--ink-2)]" data-testid="unmatched-empty">Every Xero invoice is matched to a client.</div>;
  return (
    <div data-testid="unmatched-tab">
      <div className="text-xs text-[var(--ink-2)] mb-3">Invoices are matched on the Xero contact link or exact Account Name. These {groups.reduce((a, g) => a + g.invoices.length, 0)} invoices did not match any client.</div>
      <table className="tbl tbl-ultra" data-testid="unmatched-table">
        <thead><tr><th>Xero contact</th><th className="text-right">Invoices</th><th className="text-right">Outstanding</th><th>Assign to client</th><th /></tr></thead>
        <tbody>
          {groups.map((g) => (
            <React.Fragment key={g.key}>
              <tr data-testid={`unmatched-row-${g.key}`}>
                <td><button className="underline-offset-2 hover:underline text-left" onClick={() => setOpen(open === g.key ? null : g.key)}>{g.contact_name || "(no name)"}</button></td>
                <td className="text-right font-mono-data">{g.invoices.length}</td>
                <td className="text-right font-mono-data">{fmt(g.outstanding)}</td>
                <td>
                  <select data-testid={`unmatched-client-${g.key}`} className="input-slim text-xs w-64" value={pick[g.key] || ""} onChange={(e) => setPick({ ...pick, [g.key]: e.target.value })}>
                    <option value="">— Select client —</option>
                    {clients.map((c) => <option key={c.id} value={c.id}>{c.client_uid ? `${c.client_uid} · ` : ""}{c.client_name}</option>)}
                  </select>
                </td>
                <td className="text-right"><button data-testid={`unmatched-assign-${g.key}`} disabled={!pick[g.key]} onClick={() => assign(g)} className="btn-primary text-[11px] !py-0.5 !px-2">Assign</button></td>
              </tr>
              {open === g.key && g.invoices.map((i) => (
                <tr key={i.invoice_number} className="bg-[var(--bg)]/50 text-xs">
                  <td className="pl-6 font-mono-data">{i.invoice_number}</td><td className="text-right">{i.invoice_date}</td><td className="text-right font-mono-data">{fmt(i.amount_due)}</td><td>{i.status}</td><td />
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
}
